import { Button } from "../../../shared/ui";

type Props = {
  isCompleted: boolean;
  isTimeScheduled: boolean;
  isInProgress: boolean;
  onMarkDone: () => void;
  onStart: () => void;
  onPlan: () => void;
};

export const TaskActions = ({ isCompleted, isTimeScheduled, isInProgress, onMarkDone, onStart, onPlan }: Props) => (
  <div className="bg-white border-t border-gray-200 px-4 py-4 space-y-3">
    {!isCompleted && isTimeScheduled && (
      isInProgress ? (
        <Button
          variant="surface"
          className="border-2 border-green-500 !text-green-500"
          onClick={onMarkDone}
        >
          Arbeit beenden
        </Button>
      ) : (
        <Button
          variant="surface"
          className="border-2 border-green-500 !text-green-500"
          onClick={onStart}
        >
          Arbeit starten
        </Button>
      )
    )}
    {!isInProgress && (
      <Button
        className="!bg-[#124093] !text-white"
        onClick={onPlan}
      >
        {isTimeScheduled ? "Umdisponieren" : "Im Kalender planen"}
      </Button>
    )}
  </div>
);
